import React from "react";
import DocumentPrintPdfActions from "./DocumentPrintPdfActions";

export default function PurchaseContractDocumentActions({ contractId, contractNumber }) {
  const safeName = (contractNumber || `contract-${contractId}`).replace(/[/\\?%*:|"<>]/g, "-");

  return (
    <DocumentPrintPdfActions
      printPath={`/purchase-contracts/${contractId}/print`}
      pdfPath={`/purchase-contracts/${contractId}/pdf`}
      pdfFilename={`${safeName}.pdf`}
      printTitle={`Print purchase contract${contractNumber ? ` (${contractNumber})` : ""}`}
      pdfTitle={`Download purchase contract PDF${contractNumber ? ` (${contractNumber})` : ""}`}
      testIdPrefix={`contract-${contractNumber}`}
    />
  );
}
